import store, { subscribe } from 'shared/store'
import {
  LOAD_PRODUCT_RATINGS_CONTAINER,
  loadProductRatingsContainerAction,
} from 'shared/store/ducks/events'
import { actionNames } from 'shared/store/ducks/userSession'
import { PRODUCT_DESCRIPTION_RATINGS_SELECTOR } from 'views/assets/scripts/handleRatingsAndQnaTabsClicks'
import wordCount from 'views/assets/scripts/wordCount'
import { PRODUCT_RATINGS_AND_QNA_ID } from 'views/consts'
import loadCatalogs from 'views/containers/browser/utils/loadCatalogs'
import intersectionObserver from 'views/utils/intersectionObserver'

const hydrateRatingsComponent = async ({ props }) => {
  const { container, catalogs, locale, userSession } = props

  const productRatingsContainer = await import(
    /* webpackChunkName: "ProductRatingsContainerWithHydration" */
    './ProductRatingsContainerWithHydration'
  )
  productRatingsContainer.default({
    container,
    catalogs,
    locale,
    userSession,
  })
}

const loadRatings = async userSession => {
  const ratingsContainer = document.querySelector(
    PRODUCT_DESCRIPTION_RATINGS_SELECTOR
  )

  wordCount()

  if (!ratingsContainer) {
    return
  }

  const {
    publicConfig: { locale },
  } = store.getPublicRuntimeConfig()

  const catalogs = await loadCatalogs(locale)

  const props = { container: ratingsContainer, locale, catalogs, userSession }

  intersectionObserver({
    callback: () => store.dispatch(loadProductRatingsContainerAction(props)),
    targetElements: document.getElementById(PRODUCT_RATINGS_AND_QNA_ID),
  })

  subscribe.after.once(LOAD_PRODUCT_RATINGS_CONTAINER, hydrateRatingsComponent)
}

export default async () => {
  subscribe.after.once(actionNames.setUserSession, async ({ userSession }) => {
    await loadRatings(userSession)
  })
}
